export const uk = {
    'no-rights': 'Недостаточно прав для применения рекомендации',
    'progress-title': 'Применяем рекомендацию'
};
